import { Button } from '@/components/ui/button';
import { z } from 'zod';
import { Form, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Send } from 'lucide-react';
import { Textarea } from '@/components/ui/textarea';
import { useTranslation } from 'react-i18next';
import useFeedback from '../hooks/useFeedback';

const UserFeedbackForm = () => {
	const { t } = useTranslation();

	const { sendFeedback } = useFeedback();

	const userFeedbackSchema = z.object({
		message: z.string().min(1, t('common.error.required')),
	});

	type UserFeedbackValues = z.infer<typeof userFeedbackSchema>;

	const form = useForm<UserFeedbackValues>({
		resolver: zodResolver(userFeedbackSchema),
		defaultValues: {
			message: '',
		},
	});

	const onSubmit = (values: UserFeedbackValues) => {
		sendFeedback(values);
		form.setValue('message', '');
	};

	return (
		<Form {...form}>
			<form
				onSubmit={form.handleSubmit(onSubmit)}
				className="flex flex-col gap-4"
			>
				<FormField
					control={form.control}
					name="message"
					render={({ field }) => (
						<FormItem>
							<Textarea
								id="message"
								label={t('feedback.form.message')}
								{...field}
							/>

							<FormMessage />
						</FormItem>
					)}
				/>

				<Button type="submit" className="w-fit self-end">
					<Send className="mr-2 h-4 w-4" />
					{t('feedback.form.submit')}
				</Button>
			</form>
		</Form>
	);
};

export default UserFeedbackForm;
